import { HeaderSkeleton } from "../app/headers/Header";
import { NavbarSkeleton } from "../app/navbars/Navbar";
import { DiscoveryTabBarSkeleton } from "../discovery/DiscoveryTabBar";
import DiscoveryCollectionsSkeleton from "./DiscoveryCollectionsSkeleton";
import DiscoveryFeedSkeleton from "./DiscoveryFeedSkeleton";

/**
 * Cold-boot silhouette of the main Discovery page. Composes the per-component
 * skeletons that each mirror (and are colocated with) their real counterparts —
 * HeaderSkeleton, DiscoveryTabBarSkeleton, the collections/curated-feed
 * silhouettes, and NavbarSkeleton — so this file owns only the page-level
 * layout: the section order and the `gap-6` rhythm of DiscoveryPage's content
 * stack. Update a Discovery section and its skeleton lives next to it.
 *
 * Each piece is a pure render (no queries, no auth reads), so mounting this
 * cannot mis-render as logged-out the way mounting the real Header/Navbar/
 * DiscoveryPage would (they treat a still-null currentUser as the public
 * surface). The real page fades in over a matching silhouette.
 */
export default function DiscoveryBootSkeleton(): React.JSX.Element {
  return (
    <div className="flex h-full flex-col bg-ds-white">
      <HeaderSkeleton hasSubtitle leadingActions={1} />

      {/* Scroll body — mirrors DiscoveryPage's `flex flex-col gap-6 pb-6`
          content stack (tab bar → collections → curated feed). */}
      <div className="flex flex-1 flex-col gap-6 overflow-hidden pb-6">
        <DiscoveryTabBarSkeleton />
        <DiscoveryCollectionsSkeleton />
        <DiscoveryFeedSkeleton />
      </div>

      <NavbarSkeleton />
    </div>
  );
}
